/**
 * Default game constants
 * These are used when creating a new game
 */
export const DEFAULT_MAX_PLAYERS = 4;
export const DEFAULT_BOARD_SIZE = {
    width: 8,
    height: 8,
};
export const DEFAULT_RESOURCES = {
    startingGold: 0,
    startingWool: 4,
    woolProductionRate: 1,
    woolSellPrice: 1,
    maxWool: 50,
    maxGold: 999,
};
export const DEFAULT_ENTITY_RULES = {
    kingSheepCost: 0,
    sheepCost: 2,
    dogCost: 5,
    dachshundCost: 3,
    shepherdDogCost: 5,
    goldenDachshundCost: 6,
    goldenDachshundUpgradeCost: 3,
    maxSheepPerTile: 1,
    maxDogsPerPlayer: 3,
};
export const DEFAULT_CARD_RULES = {
    enabled: true,
    lambCardCostWool: 8,
    maxHandSize: 5,
    cardsPerTurn: 1,
    marketSize: 3,
    deckComposition: {
        DOUBLE_PRICE: 4,
        MOVE_BLACK_SHEEP: 4,
        PAINT_BUCKET: 3,
        WOLF_IN_SHEEPS_CLOTHING: 3,
        WOLF_PACK: 4,
    },
};
export const DEFAULT_BLACK_SHEEP_RULES = {
    enabled: true,
    movementDiceSides: 6,
    scaresSheep: true,
    scaresDogs: false,
};
import { WinConditionType } from '../types/enums.js';
export const DEFAULT_WIN_CONDITION = {
    type: WinConditionType.MOST_SHEEP,
    maxTurns: 30,
};
export const PLAYER_COLORS = [
    '#ef4444', // red-500
    '#3b82f6', // blue-500
    '#22c55e', // green-500
    '#eab308', // yellow-500
    '#a855f7', // purple-500
    '#ec4899', // pink-500
    '#f97316', // orange-500
    '#06b6d4', // cyan-500
];
export const AI_STRATEGIES = ['balanced', 'aggressive', 'defensive', 'economic', 'random'];
export const RECONNECTION_TIMEOUT = 5 * 60 * 1000; // 5 minutes
export const AFK_TIMEOUT = 2 * 60 * 1000; // 2 minutes
//# sourceMappingURL=defaults.js.map